/**
 * Format currency based on currency code
 * @param amount - The amount to format (as decimal number)
 * @param currencyCode - The currency code (USD, GBP, CAD)
 * @returns Formatted currency string with appropriate symbol
 */
export function formatCurrency(amount: number, currencyCode: string = 'USD'): string {
	if (!amount && amount !== 0) return '0.00';
  
	// Ensure amount is a number and format to 2 decimal places
	const value = Number(amount).toFixed(2);
  
	// Get currency symbol based on currency code
	let symbol = '$'; // Default to USD
  
	switch (currencyCode.toUpperCase()) {
	  case 'GBP':
		symbol = '£';
		break;
	  case 'CAD':
		symbol = '$';
		break;
	  case 'USD':
	  default:
		symbol = '$';
		break;
	}
  
	return `${symbol}${value}`;
  }
  
  /**
   * Get currency symbol for a given currency code
   * @param currencyCode - The currency code (USD, GBP, CAD)
   * @returns Currency symbol
   */
  export function getCurrencySymbol(currencyCode: string = 'USD'): string {
	switch (currencyCode.toUpperCase()) {
	  case 'GBP':
		return '£';
	  case 'CAD':
		return '$';
	  case 'USD':
	  default:
		return '$';
	}
  }
  